import {ReactKeycloakProvider} from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import PropTypes from 'prop-types';
import React from 'react';
import {MutationCache, QueryCache, QueryClient, QueryClientProvider} from 'react-query';
import {ReactQueryDevtools} from 'react-query/devtools';

import {DetailsContextProvider} from '@/contexts/DetailsContext';
import {DialogsContextProvider} from '@/contexts/DialogsContext';
import {MultiDialogsContextProvider} from '@/contexts/MultiDialogsContext';
import SecurityProvider from '@/contexts/SecurityProvider';

const queryCache = new QueryCache();
const mutationCache = new MutationCache();
const queryClient = new QueryClient({queryCache, mutationCache});

const isDatysActive = JSON.parse(process.env.REACT_APP_DATYS_ACTIVE || false);

const keycloak = isDatysActive ?
  new Keycloak({
    url: process.env.REACT_APP_DATYS_URI,
    realm: process.env.REACT_APP_DATYS_REALM || 'CUBA',
    clientId: process.env.REACT_APP_DATYS_CLIENTID || 'onat',
  }) :
  {
    init: () => Promise.resolve({}),
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    updateToken: () => Promise.resolve(true),
    clearToken: () => {
    },
    authenticated: false,
    token: undefined,
    tokenParsed: undefined,
  };

let config = {};

if (isDatysActive)
  config = {
    checkLoginIframe: false,
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    onLoad: 'check-sso'
  };

export const AppContextProvider = ({children}) => {
  
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={config}
    >
      <QueryClientProvider client={queryClient}>
        <SecurityProvider>
          <DialogsContextProvider>
            <MultiDialogsContextProvider>
              <DetailsContextProvider>
                {children}
              </DetailsContextProvider>
            </MultiDialogsContextProvider>
          </DialogsContextProvider>
          <ReactQueryDevtools position="bottom-right"/>
        </SecurityProvider>
      </QueryClientProvider>
    </ReactKeycloakProvider>
  );
};

AppContextProvider.propTypes = {
  children: PropTypes.object,
};
